import { MutableRefObject, PropsWithChildren } from 'react';
import Button from '~/components/buttons/NewButton';
import IconPrint from '~/icons/icon-print.svg?react';
import { usePrintPDF } from '~/utils/print';

export interface PrintButtonProps {
  element: MutableRefObject<HTMLDivElement | null>;
  onSuccess?: () => void;
}

export const PrintButton: React.FC<PropsWithChildren<PrintButtonProps>> = ({ children, element, onSuccess }) => {
  const printPDF = usePrintPDF();

  const handlePDF = () => {
    if (!element.current) {
      return;
    }
    printPDF.mutateAsync(
      { element: element.current },
      {
        onSuccess,
      },
    );
  };

  return (
    <Button variant="outlined" loading={printPDF.isPending} onClick={handlePDF} Icon={IconPrint}>
      {children}
    </Button>
  );
};
